/* eslint react/no-direct-mutation-state: "off", 'no-useless-escape' : 'off', eqeqeq: 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Table } from 'reactstrap';
import moment from 'moment';
import { GetAfterHoursInvoiceData, SaveAfterHourDetails } from '../../../../../action/invoiceAction';
import Currencies from '../../../../../Resources/Currencies';
import DMResources from '../../../../../Resources/DMResources.en-US';
import Conversions from '../../../../../Resources/Conversions';

class InvoiceDetail extends Component {
    componentWillMount() {
        this.setState({
            tenants_usage_data : JSON.parse(this.props.Usage),
            tenants_fixed_data : JSON.parse(this.props.Fixed)
        });
    }

    componentDidMount() {
        this.setState({UserPreferenceFormat:this.props.UserPreference_response});
        let Year = this.props.FromDate.getFullYear().toString(), Month = (this.props.FromDate.getMonth() + 1).toString(), Day = this.props.FromDate.getDate().toString();
        let from = Year + (parseInt(Month) > 9 ? Month : "0" + Month) + (parseInt(Day) > 9 ? Day : "0" + Day);
        this.state.from_Date = from;

        let l_Year = this.props.ToDate.getFullYear().toString(), l_Month = (this.props.ToDate.getMonth() + 1).toString(), l_Day = this.props.ToDate.getDate().toString();
        let to = l_Year + (parseInt(l_Month) > 9 ? l_Month : "0" + l_Month) + (parseInt(l_Day) > 9 ? l_Day : "0" + l_Day);
        this.state.to_Date = to;

        if (this.props.TenantId != null)
            this.props.GetAfterHoursInvoiceData(this.props.TenantId, from, to);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            this.setState({ tenants_AfterHour_data: nextProps.TenantAfterHourDetails.filter(x => x.changeRequestId > 0), UserPreferenceFormat:nextProps.UserPreference_response });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            tenants_AfterHour_data: null,
            tenants_usage_data: null,
            tenants_fixed_data: null,
            NumberExpression: /^(\-?\d{1,3}([,]\d{3})*|(\-?\.?\d+))(\.\d+)?$/,
            selectedTransaction: [],
            selectedUsage: [],
            selectedFixed: [],
            ErrorAdjustHourIds: [],
            ErrorAdjustRateIds: [],
            ErrorUsageHourIds: [],
            ErrorUsageRateIds: [],
            ErrorFixedChargeIds: [],
            from_Date:'00010101',
            to_Date:'00010101',
            UserPreferenceFormat : []

        };
        this.EditAdjustedHours = this.EditAdjustedHours.bind(this);
        this.EditUsageMeter = this.EditUsageMeter.bind(this);
        this.EditFixedCharge = this.EditFixedCharge.bind(this);
        this.SaveAfterHours = this.SaveAfterHours.bind(this);
    }

    EditAdjustedHours(e) {
        let RequestId = e.target.getAttribute('changerequestid');
        let types = e.target.getAttribute('types');
        let temp_data = this.state.tenants_AfterHour_data;
        let temp_trans = (types == 'AdjustHour') ? this.state.ErrorAdjustHourIds : (types == 'AdjustRate') ? this.state.ErrorAdjustRateIds : [];
        let data = true;
        if (data) {
            temp_data.forEach(element => {
                if (element.changeRequestId == RequestId) {
                    if (types == 'AdjustHour')
                        element.adjustedHours = Conversions.getInvariantNumber(this.state.UserPreferenceFormat,e.target.value);
                    else if (types == 'AdjustRate')
                        element.adjustedRate = Conversions.getInvariantNumber(this.state.UserPreferenceFormat,e.target.value);

                    if(!(this.state.selectedTransaction.filter(x => x == RequestId).length > 0)){    
                        this.state.selectedTransaction.push(RequestId);
                    }
                }
            });

            if (types == 'AdjustHour') {
                this.setState({
                    tenants_AfterHour_data: temp_data,
                    ErrorAdjustHourIds: temp_trans.filter(x => x != RequestId)
                });
            }
            else if (types == 'AdjustRate') {
                this.setState({
                    tenants_AfterHour_data: temp_data,
                    ErrorAdjustRateIds: temp_trans.filter(x => x != RequestId)
                });
            }

        }
        else {
            if (types == 'AdjustHour') {
                temp_trans.push(RequestId);
                this.setState({
                    ErrorAdjustHourIds: temp_trans
                });
            } else if (types == 'AdjustRate') {
                temp_trans.push(RequestId);
                this.setState({
                    ErrorAdjustRateIds: temp_trans
                });
            }
        }

    }

    EditUsageMeter(e) {
        let meterId = e.target.getAttribute('MeterId');
        let types = e.target.getAttribute('types');
        let temp_data = this.state.tenants_usage_data;
        let temp_trans = (types == 'AdjustHour') ? this.state.ErrorUsageHourIds : (types == 'AdjustRate') ? this.state.ErrorUsageRateIds : [];
        let data = true;
        if (data){ //this.state.NumberExpression.test(e.target.value)) {
            temp_data.forEach(element => {
                if (element.consumptionId == meterId) {
                    if (types == 'AdjustHour')
                        element.totalUsageAmount = Conversions.getInvariantNumber(this.state.UserPreferenceFormat,e.target.value);
                    else if (types == 'AdjustRate')
                        element.rate = Conversions.getInvariantNumber(this.state.UserPreferenceFormat,e.target.value);

                    if (!(this.state.selectedUsage.filter(x => x == meterId).length > 0)) {
                        this.state.selectedUsage.push(meterId);
                    }
                }
            });

            if (types == 'AdjustHour') {
                this.setState({
                    tenants_usage_data: temp_data,
                    ErrorUsageHourIds: temp_trans.filter(x => x != meterId)
                });
            }
            else if (types == 'AdjustRate') {
                this.setState({
                    tenants_usage_data: temp_data,
                    ErrorUsageRateIds: temp_trans.filter(x => x != meterId)
                });
            }

        }
        else {
            if (types == 'AdjustHour') {
                temp_trans.push(meterId);
                this.setState({
                    ErrorUsageHourIds: temp_trans
                });
            } else if (types == 'AdjustRate') {
                temp_trans.push(meterId);
                this.setState({
                    ErrorUsageRateIds: temp_trans
                });
            }
        }

    }

    EditFixedCharge(e) {
        let fixedChargeId = e.target.getAttribute('fixedChargeId');
        let temp_data = this.state.tenants_fixed_data;
        let temp_trans = this.state.ErrorFixedChargeIds;
        let data = true;
        if (data){ //this.state.NumberExpression.test(e.target.value)) {
            temp_data.forEach(element => {
                if (element.fixedChargeId == fixedChargeId) {
                    element.fixedRate = Conversions.getInvariantNumber(this.state.UserPreferenceFormat,e.target.value);

                    if (!(this.state.selectedFixed.filter(x => x == fixedChargeId).length > 0)) {
                        this.state.selectedFixed.push(fixedChargeId);
                    }
                }
            });

            this.setState({
                tenants_fixed_data: temp_data,
                ErrorFixedChargeIds: temp_trans.filter(x => x != fixedChargeId)
            });
        }
        else {
            temp_trans.push(fixedChargeId);
            this.setState({
                ErrorFixedChargeIds: temp_trans
            });
        }
    }

    SaveAfterHours() {
        if (this.state.selectedTransaction.length > 0) {
            let Requests = [];
            this.state.tenants_AfterHour_data.forEach(element => {
                if (this.state.selectedTransaction.filter(x => x == element.changeRequestId).length > 0) {
                    var Request = {
                        "changeRequestId": element.changeRequestId,
                        "adjustedHours": parseFloat(element.adjustedHours),
                        "adjustedRate": parseFloat(element.adjustedRate)
                    }
                    Requests.push(Request);
                }
            });

            this.props.SaveAfterHourDetails(Requests,this.props.TenantId,this.state.from_Date,this.state.to_Date);
        }
    }

    compareDates(startDate,endDate)
    {
        return moment(startDate).diff(moment(endDate)) == 0 ? true : false;
    }

    render(getLabels, UserPreference_response) {
        let Tenant_AfterHour_Details = 'No Record Found', Tenant_Usage_Details = 'No Record Found', Tenant_FixedCharge_Details = 'No record Found';
        let Total_AfterHour = 0, Scheduled_Hrs_Total = 0, Billed_Hrs_Total = 0, AfterHours_Total = 0, Total_Usage = 0, Total_Fixed = 0, Gross_Total = 0, Block_Redirct = false;
        // let options = { weekday: 'short', day: 'numeric', year: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hour12: 'true' };
        //var dateTimeFormat = new Intl.DateTimeFormat('en-US', options);
        var CloseModal = this.props.CloseModal;
        var handleToUpdate  =   this.props.handleToUpdate;

        let label = this.props.getLabels;
        let PreferedDateFormat = this.state.UserPreferenceFormat;

        if (this.state.tenants_AfterHour_data != null && this.state.tenants_AfterHour_data.length > 0 && this.state.tenants_AfterHour_data.changeRequestId != 0) {

            Total_AfterHour = Number(this.state.tenants_AfterHour_data.reduce((prev, next) => prev + (next.adjustedHours * next.adjustedRate), 0)).toFixed(2);
            Scheduled_Hrs_Total = Number(this.state.tenants_AfterHour_data.reduce((prev, next) => prev + (next.scheduledHours), 0)).toFixed(2);
            Billed_Hrs_Total = Number(this.state.tenants_AfterHour_data.reduce((prev, next) => prev + (parseFloat(next.adjustedHours)), 0)).toFixed(2);
            AfterHours_Total = Number(this.state.tenants_AfterHour_data.reduce((prev, next) => prev + (next.totalAmount), 0)).toFixed(2);

            Tenant_AfterHour_Details = this.state.tenants_AfterHour_data.map((el, i) => {
                let HrsReq = Number(el.scheduledHours).toFixed(2);
                let HrsBilled = Number(el.adjustedHours).toFixed(2);
                let ContractRt = Number(el.contractRate).toFixed(2);
                let AdjRt = Number(el.adjustedRate).toFixed(2);
                let Tot = Number(el.totalAmount).toFixed(2);
                let AdjTot = Number(el.adjustedHours * el.adjustedRate).toFixed(2);
                return <tr>
                    <td>{this.compareDates(new Date(el.startTime), new Date("0001-01-01T00:00:00")) ? el.strActualStartTime : el.strStartTime }</td>
                    <td>{el.strEndTime}</td>
                    <td>{el.buildingZone}</td>
                    <td>{el.occupant}</td>
                    <td style={{ textAlign: "right" }}>{Conversions.formatNumber(PreferedDateFormat,HrsReq)}</td>
                    <td style={{ textAlign: "right" }}><input type="text" style={{ textAlign: "right", width: "60px" }} changerequestid={el.changeRequestId} defaultValue={Conversions.formatNumber(PreferedDateFormat,HrsBilled)} types='AdjustHour' onBlur={this.EditAdjustedHours} />
                        {this.state.ErrorAdjustHourIds.filter(x => x == el.changeRequestId).length > 0 ? (<label style={{ color: 'red' }}>&nbsp;!</label>) : ('')}</td>
                    <td style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(el.currencyId)}{' '}{Conversions.formatNumber(PreferedDateFormat,ContractRt)}</td>
                    <td style={{ textAlign: "right" }}><input type="text" style={{ textAlign: "right", width: "60px" }} changerequestid={el.changeRequestId} defaultValue={Conversions.formatNumber(PreferedDateFormat,AdjRt)} types='AdjustRate' onBlur={this.EditAdjustedHours} />
                        {this.state.ErrorAdjustRateIds.filter(x => x == el.changeRequestId).length > 0 ? (<label style={{ color: 'red' }}>&nbsp;!</label>) : ('')}</td>
                    <td style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(el.currencyId)}{' '}{Conversions.formatNumber(PreferedDateFormat,Tot)}</td>
                    {/* <td style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(el.currencyId)}{' '}{Number(el.adjustedTotal).toFixed(2)}</td> */}
                    <td style={{ textAlign: "right" }}>
                    {Currencies.CurrencySymbol(el.currencyId)}{' '}{Conversions.formatNumber(PreferedDateFormat,AdjTot)}</td>
                </tr>
            });
        }

        if (this.state.tenants_usage_data != null && this.state.tenants_usage_data.length > 0) {

            Total_Usage = Number(this.state.tenants_usage_data.reduce((prev, next) => prev + (next.totalUsageAmount * (next.rate > 0 ? next.rate : 1)), 0)).toFixed(2)

            Tenant_Usage_Details = this.state.tenants_usage_data.map((el, i) => {
                let TotUsage = Number(parseFloat(el.totalUsageAmount)).toFixed(2);
                let FTotUsage = Conversions.formatNumber(PreferedDateFormat,TotUsage);
                let Rate = Number(el.rate).toFixed(2);
                let FRate = Conversions.formatNumber(PreferedDateFormat,Rate);
                let Tot = Number(el.totalUsageAmount * (el.rate > 0 ? el.rate : 1)).toFixed(2);
                let BeginningReading = Number(parseFloat(el.readingDetails.startReading)).toFixed(2);
                let BeginningReadingDisplay = Conversions.formatNumber(PreferedDateFormat,BeginningReading);
                let EndingReading = Number(parseFloat(el.readingDetails.endReading)).toFixed(2);
                let EndingReadingDisplay = Conversions.formatNumber(PreferedDateFormat,EndingReading);
                return <tr>
                    <td>{el.customName}</td>
                    <td style={{ textAlign: "right" }}>{BeginningReadingDisplay}{' '}{el.unit != 0 && el.unit != 99999 ? DMResources.FamilyList('Enum3046.'+ el.unit +'.Text') : el.unitText}</td>
                    <td style={{ textAlign: "right" }}>{EndingReadingDisplay}{' '}{el.unit != 0 && el.unit != 99999 ? DMResources.FamilyList('Enum3046.'+ el.unit +'.Text') : el.unitText}</td>
                    <td style={{ textAlign: "right" }}>{FTotUsage}{' '}{el.unit != 0 && el.unit != 99999 ? DMResources.FamilyList('Enum3046.'+ el.unit +'.Text') : el.unitText}</td>
                    <td style={{ textAlign: "right" }}>                  
                    <input type='text' style={{ textAlign: "right", width: "60px" }} MeterId={el.consumptionId} Types='AdjustHour' key={FTotUsage} defaultValue={FTotUsage} onBlur={this.EditUsageMeter} />
                    {this.state.ErrorUsageHourIds.filter(x => x == el.consumptionId).length > 0 ? (<label style={{ color: 'red' }}>&nbsp;!</label>) : ('')}</td>
                    <td style={{ textAlign: "right" }}>{FRate}{' per '}{el.unit != 0 && el.unit != 99999 ? DMResources.FamilyList('Enum3046.'+ el.unit +'.Text') : el.unitText}</td>
                    <td style={{ textAlign: "right" }}>
                    <input type='text' style={{ textAlign: "right", width: "60px" }} MeterId={el.consumptionId} Types='AdjustRate' key={FRate} defaultValue={FRate} onBlur={this.EditUsageMeter} />
                    {this.state.ErrorUsageRateIds.filter(x => x == el.consumptionId).length > 0 ? (<label style={{ color: 'red' }}>&nbsp;!</label>) : ('')}</td>
                    <td style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(this.props.Currency)}{' '}{Conversions.formatNumber(PreferedDateFormat,Tot)}</td>
                </tr>
            });
        }

        if (this.state.tenants_fixed_data != null && this.state.tenants_fixed_data.length > 0) {

            Total_Fixed = Number(this.state.tenants_fixed_data.reduce((prev, next) => prev + (parseFloat(next.fixedRate)), 0)).toFixed(2);

            Tenant_FixedCharge_Details = this.state.tenants_fixed_data.map((el, i) => {
                let FRate = Number(el.fixedRate).toFixed(2);
                let FormatRate = Conversions.formatNumber(PreferedDateFormat,FRate);
                return <tr>
                    <td>{el.fixedChargeName}</td>
                    <td style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(this.props.Currency)}{' '}{FormatRate}</td>
                    <td style={{ textAlign: "right" }}><input type='text' style={{ textAlign: "right", width: "60px" }} fixedChargeId={el.fixedChargeId} key={FormatRate} defaultValue={FormatRate} onBlur={this.EditFixedCharge} />
                    {this.state.ErrorFixedChargeIds.filter(x => x == el.fixedChargeId).length > 0 ? (<label style={{ color: 'red' }}>&nbsp;!</label>) : ('')}</td>
                </tr>
            });
        }

        Gross_Total = parseFloat(Total_AfterHour) + parseFloat(Total_Usage) + parseFloat(Total_Fixed);

        Block_Redirct = this.state.selectedFixed.length > 0 || this.state.selectedUsage.length > 0;

        return (
            <div>
                <div>
                    {/* <Form>    */}
                    <b><label style={{fontFamily:'Verdana',fontSize:'12px'}}>{label['TenantConsumption.InvoiceDetails.Text'] !== undefined ? label['TenantConsumption.InvoiceDetails.Text'] : "Invoice Details"}</label></b><br />
                    <b><label style={{fontFamily:'Verdana',fontSize:'12px',fontWeight:'bold'}}>Tenant: </label></b>{' '}{this.props.TenantName}<br />
                    {/* </Form> */}
                </div>
                {(this.state.tenants_AfterHour_data != null && this.state.tenants_AfterHour_data.length > 0 && this.state.tenants_AfterHour_data.changeRequestId != 0) ? (
                    <div className="table_container">
                        <b><label> {label['TenantBillingPreview.AfterHoursCharges.Text'] !== undefined ? label['TenantBillingPreview.AfterHoursCharges.Text'] : "After-Hours Charges"}</label></b><br />
                        <Table striped responsive className=" Custom_table table_border">
                            <tbody className="cell_container tenant_cell">
                                <tr>
                                    <th style={{ width: "10%" }}>{label['TenantBillingPreview.Columns.ChangeStart.Text'] !== undefined ? label['TenantBillingPreview.Columns.ChangeStart.Text'] : "Request Start"}</th>
                                    <th style={{ width: "10%" }}>{label['TenantBillingPreview.Columns.ChangeEnd.Text'] !== undefined ? label['TenantBillingPreview.Columns.ChangeEnd.Text'] : "Request End"}</th>
                                    <th style={{ width: "10%" }}>{label['TenantBillingPreview.Columns.BuildingZone.Text'] !== undefined ? label['TenantBillingPreview.Columns.BuildingZone.Text'] : "Zone"}</th>
                                    <th style={{ width: "12%" }}>{label['TenantBillingPreview.Columns.Occupant.Text'] !== undefined ? label['TenantBillingPreview.Columns.Occupant.Text'] : "Employee"}</th>
                                    <th style={{ textAlign: "right", width: "8%" }}>{label['TenantBillingPreview.Columns.Hours.Text'] !== undefined ? label['TenantBillingPreview.Columns.Hours.Text'] : "Hours Requested"}</th>
                                    <th style={{ textAlign: "right", width: "8%" }}>{label['TenantBillingPreview.Columns.AdjustedHours.Text'] !== undefined ? label['TenantBillingPreview.Columns.AdjustedHours.Text'] : "Hours Billed"}</th>
                                    <th style={{ textAlign: "right", width: "11%" }}>{label['TenantBillingPreview.Columns.Rates.Text'] !== undefined ? label['TenantBillingPreview.Columns.Rates.Text'] : "Contract Rate"}</th>
                                    <th style={{ textAlign: "right", width: "10%" }}>{label['TenantBillingPreview.Columns.AdjustedRates.Text'] !== undefined ? label['TenantBillingPreview.Columns.AdjustedRates.Text'] : "Adjusted Rate"}</th>
                                    <th style={{ textAlign: "right", width: "11%" }}>{label['TenantBillingPreview.Columns.Total.Text'] !== undefined ? label['TenantBillingPreview.Columns.Total.Text'] : "Total"}</th>
                                    <th style={{ textAlign: "right", width: "10%" }}>{label['TenantBillingPreview.Columns.AdjustedTotal.Text'] !== undefined ? label['TenantBillingPreview.Columns.AdjustedTotal.Text'] : "Adjusted Total"}</th>
                                </tr>
                                {Tenant_AfterHour_Details}
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th>{label['TenantConsumption.AfterHoursTotals.Text'] !== undefined ? label['TenantConsumption.AfterHoursTotals.Text'] : "After-Hours Total"}</th>
                                    <th style={{ textAlign: "right" }}>{Conversions.formatNumber(PreferedDateFormat,Scheduled_Hrs_Total)}</th>
                                    <th style={{ textAlign: "right" }}>{Conversions.formatNumber(PreferedDateFormat,Billed_Hrs_Total)}</th>
                                    <th></th>
                                    <th></th>
                                    <th style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(this.props.Currency)}{' '}{Conversions.formatNumber(PreferedDateFormat,AfterHours_Total)}</th>
                                    <th style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(this.props.Currency)}{' '}{Conversions.formatNumber(PreferedDateFormat,Total_AfterHour)}</th>
                                </tr>
                            </tbody>
                        </Table>
                    </div>) : ('')}
                {(this.state.tenants_usage_data != null && this.state.tenants_usage_data.length > 0) ? (
                    <div>
                        <b><label>{label['TenantBillingPreview.UsageCharges.Text'] !== undefined ? label['TenantBillingPreview.UsageCharges.Text'] : "Usage Charges"}</label></b><br />
                        <Table striped responsive className=" Custom_table table_border">
                            <tbody className="cell_container tenant_cell">
                                <tr>
                                    <th>{label['TenantConsumption.Charges.Text'] !== undefined ? label['TenantConsumption.Charges.Text'] : "Charge"}</th>
                                    <th style={{ textAlign: "right" }}>{label['TenantInvoices.Columns.BeginningReading.Text'] !== undefined ? label['TenantInvoices.Columns.BeginningReading.Text'] : "Beginning Reading"}</th>
                                    <th style={{ textAlign: "right" }}>{label['TenantInvoices.Columns.EndingReading.Text'] !== undefined ? label['TenantInvoices.Columns.EndingReading.Text'] : "Ending Reading"}</th>
                                    <th style={{ textAlign: "right" }}>{label['TenantInvoices.Columns.Usage.Text'] !== undefined ? label['TenantInvoices.Columns.Usage.Text'] : "Usage"}</th>
                                    <th style={{ textAlign: "right" }}>{label['TenantConsumption.AdjustedUsage.Text'] !== undefined ? label['TenantConsumption.AdjustedUsage.Text'] : "Adjusted Usage"}</th>
                                    <th style={{ textAlign: "right" }}>{label['TenantBillingPreview.Columns.Rates.Text'] !== undefined ? label['TenantBillingPreview.Columns.Rates.Text'] : "Contract Rate"}</th>
                                    <th style={{ textAlign: "right" }}>{label['TenantBillingPreview.Columns.AdjustedRates.Text'] !== undefined ? label['TenantBillingPreview.Columns.AdjustedRates.Text'] : "Adjusted Rate"}</th>
                                    <th style={{ textAlign: "right" }}>{label['TenantBillingPreview.Columns.Total.Text'] !== undefined ? label['TenantBillingPreview.Columns.Total.Text'] : "Total"}</th>
                                </tr>
                                {Tenant_Usage_Details}
                                <tr>
                                    <th colSpan='7' style={{ textAlign: "right" }}>{label['TenantConsumption.UsageTotal.Text'] !== undefined ? label['TenantConsumption.UsageTotal.Text'] : "Usage Total"}</th>
                                    <th style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(this.props.Currency)}{' '}{Conversions.formatNumber(PreferedDateFormat,Total_Usage)}</th>
                                </tr>
                            </tbody>
                        </Table>
                    </div>) : ('')}
                {(this.state.tenants_fixed_data != null && this.state.tenants_fixed_data.length > 0) ? (
                    <div>
                        <b><label>{label['TenantBillingPreview.FixedCharges.Text'] !== undefined ? label['TenantBillingPreview.FixedCharges.Text'] : "Fixed Charges"}</label></b><br />
                        <Table striped responsive className="Custom_table table_border">
                            <tbody className="cell_container tenant_cell">
                                <tr>
                                    <th>{label['TenantConsumption.Charges.Text'] !== undefined ? label['TenantConsumption.Charges.Text'] : "Charge"}</th>
                                    <th style={{ textAlign: "right" }}>{label['FixedRateSetup.ContractCharges.Text'] !== undefined ? label['FixedRateSetup.ContractCharges.Text'] : "Contract charge"}</th>
                                    <th style={{ textAlign: "right" }}>{label['FixedRateSetup.AdjustCharges.Text'] !== undefined ? label['FixedRateSetup.AdjustCharges.Text'] : "Adjusted Charge"}</th>
                                </tr>
                                {Tenant_FixedCharge_Details}
                                <tr>
                                    <th></th>
                                    <th style={{ textAlign: "right" }}>{label['FixedRateSetup.FixedChargeTotal.Text'] !== undefined ? label['FixedRateSetup.FixedChargeTotal.Text'] : "Fixed Charge Total"}</th>
                                    <th style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(this.props.Currency)}{' '}{Conversions.formatNumber(PreferedDateFormat,Total_Fixed)}</th>
                                </tr>
                            </tbody>
                        </Table>
                    </div>) : ('')}
                {((this.state.tenants_AfterHour_data != null && this.state.tenants_AfterHour_data.length > 0 && this.state.tenants_AfterHour_data.changeRequestId != 0) || (this.state.tenants_usage_data != null && this.state.tenants_usage_data.length > 0) || (this.state.tenants_fixed_data != null && this.state.tenants_fixed_data.length > 0)) ? (
                    <div>
                        <Table striped responsive className=" Custom_table">
                            <tbody>
                                <tr>
                                    <th style={{ textAlign: "right" }}>{label['TenantBillingPreview.TenantTotal.Text'] !== undefined ? label['TenantBillingPreview.TenantTotal.Text'] : "Tenant Total"}</th>
                                    <th style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(this.props.Currency)}{' '}{Conversions.formatNumber(PreferedDateFormat,Number(Gross_Total).toFixed(2))} </th>
                                </tr>
                            </tbody>
                        </Table>
                    </div>) : ('')
                }
                <div className="buttons_container" style={{ float: 'right' }}>
                    <Button type="button" className="btn btn-gray back_button" onClick={() => CloseModal()} >  {label['CreateTenant.Cancel.Text'] !== undefined ? label['CreateTenant.Cancel.Text'] : "Cancel"}   </Button>
                    <Button type="button" className="btn btn-success back_button" onClick={() => {this.SaveAfterHours(); handleToUpdate(this.state.tenants_usage_data, this.state.tenants_fixed_data, Total_AfterHour, Block_Redirct)}} >  {label['CreateTenant.AdjustHoursRateSave.Text'] !== undefined ? label['CreateTenant.AdjustHoursRateSave.Text'] : "Save and Close"}   </Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        TenantAfterHourDetails: state.InvoiceRootReducer.TenantAfterHourDetails,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetAfterHoursInvoiceData: (id, from, to) => dispatch(GetAfterHoursInvoiceData(id, from, to)),
        SaveAfterHourDetails: (data,TenantID,from,to) => dispatch(SaveAfterHourDetails(data,TenantID,from,to))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetail);